<template>
  <v-card>
    <v-card-title>Shipped To:</v-card-title>
    <v-card-text>
      <div>{{ shipToAddressInfo.Address }}</div>
      <div>{{ shipToAddressInfo.City }}, {{ shipToAddressInfo.State }} {{ shipToAddressInfo.Zip }}</div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { SofieShipToAddress } from '@/types/types';

export default defineComponent({
  props: {
    shipToAddressInfo: {
      type: Object as PropType<SofieShipToAddress>,
      required: true,
    },
  },
});
</script>
